// list of errors: https://learn.microsoft.com/cs-cz/azure/active-directory-b2c/error-codes
export const ADB2C_ERROR_CODES = {
    USER_FORGOT_PASSWORD: "AADB2C90118",
    USER_CANCELED_OPERATION: "AADB2C90091",
};
